// extracted by mini-css-extract-plugin
export var dividerLine = "_5a-0";
export var errorBackground = "_5a-1";